// Define types for our job application data
export interface JobApplication {
  id: string;
  company: string;
  position: string;
  dateApplied: string;
  status: 'applied' | 'interviewing' | 'offered' | 'rejected';
  notes?: string;
  contactName?: string;
  contactEmail?: string;
}

const API_TIMEOUT_MS = 5000;

// Create an API service with methods to fetch job applications
export const api = {
  // Get all job applications for the current user
  async getJobApplications(apiUrl: string, token: string): Promise<JobApplication[]> {
    console.log(`getJobApplications against ${apiUrl}/applications token: ${token}`);
    try {
      // Create an AbortController with a 5-second timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT_MS);

      const response = await fetch(`${apiUrl}/applications`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        signal: controller.signal
      });

      // Clear the timeout as the request has completed
      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching job applications:', error);
      throw error;
    }
  },

  // Get a single job application by ID
  async getJobApplication(apiUrl: string, id: string, token: string): Promise<JobApplication> {
    console.log(`getJobApplications against ${apiUrl}/applications/${id} token: ${token}`);
    try {
      // Create an AbortController with a 5-second timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT_MS);

      const response = await fetch(`${apiUrl}/applications/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        signal: controller.signal
      });

      // Clear the timeout as the request has completed
      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`Error fetching job application with ID ${id}:`, error);
      throw error;
    }
  }
};
